// MazePrinter
//
//  desc:
//         
//
//
//  props:
//    puzzle
//


import React, { Component } from 'react';

import './index.css';
import Room from './Room';    //importing the room component

class MazePrinter extends Component
{
  constructor(props)
  {
    super(props)
  }
  

  componentDidMount()
  {

  }
  
  

  render()
  {
    var rooms = [];
    var rows = [];
    var puzzleArray = [];
   var puzzle_width = this.props.puzzle.getWidth();
   var puzzle_height = this.props.puzzle.getHeight();
   for (var y = 0; y < puzzle_height; y++)
   {
      var tempRooms = [];
      for (var x = 0; x < puzzle_width; x++)
      {
        var roomsArray = this.props.puzzle.getRoomsArray();
        var roomLoc = x + (y * puzzle_width);
        var tempRoom = roomsArray[roomLoc];
        var tempKey = "room_" + roomLoc + "_" + tempRoom.getRoomType();
        tempRooms.push(
          <div key={tempKey}>
            <Room id={tempKey} room={tempRoom} extraClasses="puzzle_room" />
          </div>
        );
      }

      var tempRowKey = "row_" + y;
      rows.push(
          <div key={tempRowKey} id={tempRowKey} className="puzzle_row">
            {tempRooms} 
          </div>
      );
   }

  
    return(
      <div> 
        
        <div>
          {rows}
        </div>
      </div>
     
     );
  }
}


export default MazePrinter; //export the  MazePrinter component
